import React from 'react';
import { FaInfoCircle, FaRocket, FaWindowClose, 
    FaEye, FaBullseye, FaCheckSquare, FaHistory, 
    FaHandshake, FaShieldAlt, FaCrown, FaStar, FaArrowAltCircleRight, FaUserFriends} from 'react-icons/fa'; 

const AboutUs = ({setNavLinks}) => {
  return (
    <div  className='container-fluid custom-about'>

        <div className='close-window-icon' ><FaWindowClose color='#1b2328' onClick={()=>{
                  setNavLinks({homeLink: true})
                  sessionStorage.setItem("currentSession", JSON.stringify({homeLink: true}));
                  }}/> </div>
        <h1 className='title'><FaInfoCircle color='#1b2328' /> About Us </h1>


        <div className='mission-vision-core-whatWeDo-history'>

            <div className='mission'>

                <h4> <FaRocket/> Our Mission </h4>
                <p>
                    Rendering quality services at a suitable rate and building entrepreneurs.

                </p>

            </div>
            <div className='Vision'>

                 <h4> <FaEye/> Our Vision </h4>
                 <p>
                      Making Peerless Glam the leading organization in the world of 
                      business and where everybody becomes a BOSS under a growing organization/company.

                 </p>

            </div>
            <div className='Core'>

                       <h4> <FaBullseye/> Core Values </h4>

                      <p><FaHandshake color='#D4AF37'/> Mentorship</p>
                      <p><FaShieldAlt color='green'/> Professionalism</p>
                      <p><FaCrown color='rgb(252, 47, 81)'/> Leadership</p>
                      <p>< FaStar color='gold'/> Proficiency</p>

            </div>
            <div className='whatWeDo'>

                   <h4> <FaCheckSquare/> What We Do? </h4>
                   <p> We sell Human Hair, Wig and Accessories. We Revamp, Restyle old and new Wigs. We train individuals that are interested in the business. We also design graphics, design websites and applications for our clients. </p>
                   
                   <div className='services-members-btn'>

                      <div className='service-btn ' onClick={()=> {
                        
                        setNavLinks({serviceLink: true })
                        sessionStorage.setItem("currentSession", JSON.stringify({serviceLink: true}));
                        }}>Check Our Services <FaArrowAltCircleRight color='#1b2328'/></div>
                    <div className='service-btn' onClick={()=> {
                      
                      setNavLinks({membersLink: true })
                      sessionStorage.setItem("currentSession", JSON.stringify({membersLink: true}));
                      }}> Meet Our Team <FaUserFriends color='#1b2328'/></div>

                   </div>
                   
                   

            </div>

             <div className='history'>

                   <h4> <FaHistory/> History </h4>

                   <p>
                          We started 2018 with hair business training that elapsed in 2020. We are known for Credibility and Durability of our services.
                          Since we started till now, we have not failed to deliver nationwide. 
                          We evolved from JJ Hairs to PEERLESS GLAM. PEERLESS was coined by my lovely husband and GLAM from a great friend Jessica. 
                          We have come this far with the help of God and our amiable Legal Adviser Ayo-Okhiria Eromosele. Lets not forget the massive support and 
                          assistance from our Social Media Manager and Website Developer (PGTech). We also have services which entails graphic designs, web and application development. 
                          Stay connected as you journey with us. Thank you. 
                      
                   </p>

            </div>
        </div>
       

    </div>
  )
}

export default AboutUs;